import {Toast, ToastContainer} from 'react-bootstrap';

function Popup(props) {
    return (
        <ToastContainer
            className="p-3"
            position={"top-end"}
            style={{ position: 'fixed' }}
        >
            <Toast onClose={props.onClose} show={props.show} delay={5000} autohide bg={props.status}>
                <Toast.Header>
                    <strong className="me-auto" style={{fontSize: "15px"}}>
                        {props.fontAwesome}
                        {props.messageTitle}
                    </strong>
                </Toast.Header>
                <Toast.Body className={"text-white"}>{props.messageDetail}</Toast.Body>
            </Toast>
        </ToastContainer>
    );
}

export default Popup;